<template>
    <div>
        <el-row class="searchSection">
            <el-form ref="form" :inline="true" :model="searcheModel" class="external-form">
                <el-form-item label="录单时间">
                    <el-date-picker
                        size="small"
                        v-model="searcheModel.created_at"
                        type="daterange"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="应续月份">
                    <el-date-picker
                    size="small"
                    v-model="searcheModel.months"
                    type="monthrange"
                    format="yyyy-MM"
                    value-format="yyyy-MM"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="所属部门">
                    <UserCascader
                    v-model="searcheModel.branch_id"
                    ref="branch"
                    :isBusiness="true"
                    :branch_id="parseInt(searcheModel.branch_id)"
                    @change="changeBranch"
                    ></UserCascader>
                </el-form-item>
                <el-form-item label="业务员">
                    <UserSelect ref="user" :uid="parseInt(searcheModel.user_id)" @change="changeUser"></UserSelect>
                </el-form-item>
                <el-form-item label="是否上传合同或回款">
                    <el-select size="small" v-model="searcheModel.contract_or_actual" placeholder="请选择">
                        <el-option label="不限" value=""></el-option>
                        <el-option label="通过" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="财务审核">
                    <el-select size="small" v-model="searcheModel.finance_audit" placeholder="请选择">
                        <el-option label="不限" value=""></el-option>
                        <el-option label="通过" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="续费完成时间">
                    <el-date-picker
                        size="small"
                        v-model="searcheModel.renew_finish_at"
                        type="daterange"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="续费类型">
                    <el-select size="small" v-model="searcheModel.renew_type" placeholder="请选择">
                        <el-option label="不限" value=""></el-option>
                        <el-option label="提前续费" value="6"></el-option>
                        <el-option label="准时续费" value="7"></el-option>
                        <el-option label="延迟续费" value="8"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="过滤销售额为0的订单">
                    <el-select size="small" v-model="searcheModel.not_have_amount" placeholder="请选择">
                        <el-option label="不限" value=""></el-option>
                        <el-option label="是" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="submitSearch">搜索</el-button>
                    <el-button @click="resetForm()" size="small">重置</el-button>
                    <ExportFile 
                    v-if="Acs('/sale-analysis/goal-finish')"
                    :url="'/api/export/' + activeName" 
                    :params="searcheModel" 
                    filename="续费明细表" 
                    buttonName="导出Excel">
                    </ExportFile>
                </el-form-item>
            </el-form>
        </el-row>
        <el-row class="searchSection">
            <el-col :span="18">
                <h5 style="color:#85CE61;">协作单已按照业务员个人业绩占比拆分，计算续费的产品为二一校网通、二一组卷、校本资源库</h5>
            </el-col>
            <el-col :span="2">
                <TableFields :path="$route.path" :tab="searcheModel.tab" :fields="fields" :key="count_config_key" @change="changeSearchFields"></TableFields>
            </el-col>
            <el-col :span="2" :offset="2">
                <CountConfig v-if="Acs('/count-config/view')" :path="$route.path" :tab="searcheModel.tab" :key="count_config_key"></CountConfig>
            </el-col>
        </el-row>
        <div v-loading="loading">
            <el-table 
            v-if="!loading"
            :data="list" 
            border 
            height="650"
            :header-cell-style="{background: '#f3faff'}"
            >
                <template v-for="(item, index) in fields">
                    <el-table-column :prop="item.field" :label="item.label" v-if="checked_fields.includes(item.field)" v-bind="{ width: item.width }" :key="index">
                        <template slot="header" v-if="item.content">
                            <span>{{item.label}}</span>
                            <el-tooltip class="item" effect="dark" :content="item.content" placement="top">
                                <i class="el-icon-info"></i>
                            </el-tooltip>
                        </template>
                        <template slot-scope="scope">
                            <el-button type="text" @click="handleView(scope.row)" v-if="item.click">
                                {{ scope.row[item.field] instanceof Array ? scope.row[item.field].join(',') : scope.row[item.field] }}
                            </el-button>
                            <span v-else>
                                {{ scope.row[item.field] instanceof Array ? scope.row[item.field].join(',') : scope.row[item.field] }}
                            </span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
            <MyPagination :linkPage="linkPage" @size-change="handleSizeChange" @current-change="handleCurrentChange"></MyPagination>
        </div>
    </div>
  </template>
  <style scoped>
  
  </style>
  <script>
  import SaleanalysisCount from "~/services/saleanalysisCount";
  import UserCascader from "~/widgets/UserCascader.vue";
  import UserSelect from "~/widgets/UserSelect.vue";
  import Config from "~/config/params";
  import ExportFile from "~/widgets/ExportFile.vue";
  import CountConfig from "~/widgets/CountConfig.vue";
  import TableFields from "~/widgets/TableFields.vue";
  import MyPagination from "~/widgets/MyPagination.vue";
  export default {
  
    components: {
        UserCascader,
        UserSelect,
        Config,
        ExportFile,
        CountConfig,
        TableFields,
        MyPagination
    },
  
    props: {
        activeName: {
            type: String,
            default: ''
        } 
    },
  
    data() {
        return {
            loading: false,
            searcheModel: {},
            // 分页信息
            linkPage: null,
            list: [],
            count_config_key: 0,
            fields: [
                {field: 'order_id', label: '订单ID', click: true},
                {field: 'branch_name', label: '所属部门'},
                {field: 'name', label: '业务员'},
                {field: 'district_names', label: '所在地区'},
                {field: 'created_at', label: '录单时间'},
                {field: 'customer_name', label: '客户名称'},
                {field: 'invoice_title', label: '发票抬头'},
                {field: 'order_type', label: '订单类型'},
                {field: 'product_id1', label: '二一组卷'},
                {field: 'product_id2', label: '二一校网通'},
                {field: 'product_id4', label: '校本2'},
                {field: 'product_id5', label: '校本3'},
                {field: 'to_renew_amount', label: '应续金额', content:'校网通+组卷+校本产品价格', width: 100},
                {field: 'contract_year', label: '合作年限', content:'(合同结束时间-合同开始时间)/365', width: 100},
                {field: 'contract_times', label: '合同时间'},
                {field: 'to_renew_month', label: '应续月份', content:'合同到期时间的月份', width: 100},
                {field: 'order_num', label: '订单数量'},
                {field: 'order_memo', label: '订单备注'},
                {field: 'customer_user_name', label: '绑定业务员'},
                {field: 'customer_user_name', label: '应续业务员', content:'客户绑定人', width: 110},
                {field: 'renew_order_ids', label: '续费订单ID'},
                {field: 'renew_order_user_names', label: '实续业务员', content:'续约目标单对应的续费订单负责人', width: 110},
                {field: 'renew_created_at', label: '续费录单时间'},
                {field: 'finish_at', label: '续费完成时间'},
                {field: 'renew_contract_times', label: '续费合同时间'},
                {field: 'finish_amount', label: '续费完成额'},
                {field: 'finish_order_num', label: '实续订单数量'},
                {field: 'renew_types', label: '续费类型'},
            ],
            checked_fields: []
        };
    },
  
    mounted() {
        // console.log('mounted: ', this.$route.query);
    },
  
    created() {
        this.resetForm(this.$route.query);
    },
  
    methods: {
        //重置按钮
        resetForm(params = null) {
            this.list = [];
            if(params && Object.keys(params).length > 0){
                this.searcheModel = Object.assign({}, this.searcheModel, params);
            }else{
                this.searcheModel = {
                    branch_id: "",
                    user_id: "",
                    path: this.$route.path,
                    tab: 'goal-manage-renew',
                    months: Config.getDataTimes('this_month'),
                    created_at: [],
                    renew_finish_at: Config.getDataTimes('this_month'),
                    contract_or_actual: '',
                    finance_audit: '',
                    renew_type: '',
                    not_have_amount: '',
                };
                if(this.$refs['user']){
                    this.$refs['user'].reset();
                }
                if(this.$refs['branch']){
                    this.$refs['branch'].reset();
                }
            }
            // console.log('resetForm:', this.searcheModel);
            this.submitSearch();
        },
    
        // 筛选查询
        submitSearch() {
            let params = _.clone(this.searcheModel);
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            })
            this.getList(params);
        },
    
        //获取列表
        getList(params) {
            // loading 动画
            this.loading = true;
            SaleanalysisCount.getList(params, this.activeName).then((res) => {
                if (res.code == 0) {
                    this.list = res.data;
                }
                if (res._meta) {
                    this.linkPage = res._meta;
                }
                this.loading = false;
            }).catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },
    
        //切换业务员子组件
        changeUser(object) {
            this.searcheModel.user_id = object.label;
        },

        //切换部门子组件
        changeBranch(value) {
            if (value.length > 0) {
                // 取得最后一级部门作为所属部门
                this.searcheModel.branch_id = value[value.length - 1];
            } else {
                this.searcheModel.branch_id = "";
            }
        },

        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                // 第一列不计算合计，显示自定义的文字内容
                if (index === 0) {
                    sums.push('合计：' + data.length + '条');
                    return;
                }
                // 初始化合计值为0
                let sum = 0;
                // 遍历数据，累加顶级行的值
                data.forEach(item => {
                    // 累加当前项的值，注意转换为数字
                    sum += Number(item[column.property]);
                });
                // 如果所有值都是数字，则显示合计结果，否则显示'-'
                if (!isNaN(sum)) {
                    sums.push(Math.round(sum * 100) / 100); // 保留两位小数
                } else {
                    sums.push('--');
                }
            });
            return sums;
        },

        // 查看
        handleView(row) {
            let routeData = this.$router.resolve({
                path: "/order/view",
                query: {id: row.order_id},
            });
            window.open(routeData.href, '_blank');
        },

        changeSearchFields(val){
            this.checked_fields = val;
            // console.log('changeSearchFields', val, this.checked_fields)
        },

        handleSizeChange(newSize) {
            // 处理每页条目数变化事件
            this.searcheModel['perPage'] = newSize;
            this.submitSearch();
        },

        handleCurrentChange(newPage) {
            // 处理当前页码变化事件
            this.searcheModel['page'] = newPage;
            this.submitSearch();
        },
    },
  };
  </script>


// WEBPACK FOOTER //
// src/views/count/table/goalFinishDetail.vue